import http from "src/shared/http";
import camelize from "camelize";
import { MaybePromise } from "@reduxjs/toolkit/dist/query/tsHelpers";
import { ThunkDispatch } from "@reduxjs/toolkit";

export type BaseQueryFn<
  Args = any,
  Result = unknown,
  Error = unknown,
  DefinitionExtraOptions = {},
  Meta = any
> = (
  args: Args,
  api: BaseQueryApi,
  extraOptions: DefinitionExtraOptions
) => MaybePromise<QueryReturnValue<Result, Error, Meta>>;

export interface BaseQueryApi {
  signal: AbortSignal;
  dispatch: ThunkDispatch<any, any, any>;
  getState: () => unknown;
}

export type QueryReturnValue<T = unknown, E = unknown, M = any> =
  | {
      error: E;
      data?: undefined;
      meta?: M;
    }
  | {
      error?: undefined;
      data: T;
      meta?: M;
    };

interface HttpQueryParams {
  url: string;
  method?: string;
  body?: object;
  params?: object;
}

const httpBaseQuery =
  () =>
  async ({
    url,
    method = "get",
    body,
    params,
  }: HttpQueryParams): Promise<QueryReturnValue<{ data: any; error: any }>> => {
    try {
      const result = await http(url, { method, body, params });
      if (!result.status.toString().startsWith("2")) {
        throw new Error("Http Status isn't 2xx");
      }
      const camelizedResult = camelize(result.data); // TODO This should be done in backend.
      return { data: camelizedResult };
    } catch (error) {
      return {
        error: (error as Error)?.message,
      };
    }
  };

export default httpBaseQuery;
